import React from 'react';
import { TrendingUp } from 'lucide-react';

export const Logo = ({ variant = 'dark' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-[#0F2A4A]';
  const gradientId = `logo-gradient-${variant}`;

  return (
    <div className="flex items-center space-x-3">
      {/* Hexagonal Icon with Gradient */}
      <div className="relative w-10 h-10">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3FC9E8" />
              <stop offset="100%" stopColor="#1A9FE0" />
            </linearGradient>
          </defs>
          {/* Hexagon Path */}
          <path
            d="M20 2L35 11V29L20 38L5 29V11L20 2Z"
            stroke={`url(#${gradientId})`}
            strokeWidth="2"
            fill="none"
          />
          {/* Bar Chart */}
          <rect x="12" y="24" width="3" height="8" fill={`url(#${gradientId})`} />
          <rect x="18" y="20" width="3" height="12" fill={`url(#${gradientId})`} />
          <rect x="24" y="16" width="3" height="16" fill={`url(#${gradientId})`} />
          {/* Arrow */}
          <path d="M28 12L32 8L36 12M32 8V20" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Text Logo */}
      <div className="flex flex-col leading-none">
        <span className={`text-xs ${textColor} opacity-70 uppercase tracking-wide`} style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          THE
        </span>
        <div className="flex items-baseline">
          <span className={`text-2xl font-bold ${textColor}`} style={{ fontFamily: 'Outfit, sans-serif' }}>
            B<span style={{ background: 'linear-gradient(135deg, #3FC9E8 0%, #1A9FE0 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>2</span>B
          </span>
        </div>
        <span className={`text-xs ${textColor} opacity-70 uppercase tracking-wide`} style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
          DIGITAL
        </span>
      </div>
    </div>
  );
};

export default Logo;